import { Injectable } from "@angular/core";
import { MapperInterface } from "@app/shared/mapper/mapper-inteface";
import { UnitaDocumentariaDTO } from "../dto/unita-documentariaDTO";
import { UnitaDocumentariaVO } from "../vo/unita-documentariaVO";
import { MapperClassifica } from "./mapper-classifica";
import { MapperDocumento } from "./mapper-documento";
import { MapperRiferimentiPosizione } from "./mapper-riferimenti-posizione";
import { MapperTempiConservazione } from "./mapper-tempi-conservazione";
import { MapperCampoSpecificoFascicolo } from "./mapper-campo-specifico-fascicolo";
import { MapperUtente } from "./mapper-utente";
import { MapperSettoreStruttura } from "./mapper-settore-struttura";
import { MapperMetadatiProtocollo } from "./mapper-metadati-protocollo";
import { MapperVisibilitaFascicolo } from "./mapper-visibilita-fascicolo";
import { MapperMetadatiRepertorio } from "./mapper-metadati-repertorio";
import { MapperMetaDatiFascicolo } from "./gescor/mapper-metadati-fascicolo";
import { MapperLingua } from "./mapper-lingua";
import { MapperDatiRepertorioManuali } from "./mapper-dati-repertorio-manuali";
import { MapperSettore } from "./mapper-settore";
import { MapperDatiPersonali } from "./mapper-dati-personali";

@Injectable({
  providedIn: "root",
})
export class MapperUnitaDocumentaria
  implements MapperInterface<UnitaDocumentariaDTO, UnitaDocumentariaVO> {
  constructor(
    private classificaMapper: MapperClassifica,
    private mapperRiferimentiPosizione: MapperRiferimentiPosizione,
    private mapperSettoreStruttura: MapperSettoreStruttura,
    private mapperMetadatiProtocollo: MapperMetadatiProtocollo,
    private mapperUtente: MapperUtente,
    private mapperTempiConservazione: MapperTempiConservazione,
    private mapperVisibilitaFascicolo: MapperVisibilitaFascicolo,
    private mapperMetadatiRepertorio: MapperDatiRepertorioManuali,
    private documentoMapper: MapperDocumento,
    private mapperMetaDatiFascicolo: MapperMetaDatiFascicolo,
    private visibilitaElementoMapper: MapperVisibilitaFascicolo,
    private mapperLingia: MapperLingua,
    private mapperSettore: MapperSettore,
    private mapperDatiPersonali: MapperDatiPersonali
  ) { }
  convertVoToDto(vo: UnitaDocumentariaVO): UnitaDocumentariaDTO {
    if (vo != null) {
      console.log("mappr dentro vo", JSON.stringify(vo));
      const dto = new UnitaDocumentariaDTO();
      //     dto.riservato = vo.riservato;
      dto.protocollato = false;
      dto.collocazioneFisica = vo.collocazioneFisica;
      dto.classifica = this.classificaMapper.convertVoToDto(vo.classifica);

      dto.classificaAggiuntiva = this.classificaMapper.convertVoToDto(
        vo.classificaAggiuntiva
      );

      dto.riferimentoPosizione = this.mapperRiferimentiPosizione.convertVoToDto(
        vo.riferimentoPosizione
      );
      dto.oggetto = vo.oggetto;
      dto.id = vo.id;
      dto.tipo = vo.tipo;
      dto.visibilitaElemento = this.mapperVisibilitaFascicolo.convertListVoToDto(
        vo.visibilitaElemento
      );
      dto.inseritoDa = this.mapperUtente.convertVoToDto(vo.inseritoDa);
      dto.dataUltimaModifica = vo.dataUltimaModifica;
      dto.dataArchiviazione = vo.dataArchiviazione;
      dto.dataInserimentoFascicolo = vo.dataInserimentoFascicolo;
      dto.dataInserimento = vo.dataInserimento;
      if (vo.stato === "In lavorazione") {
        dto.stato = "IN_LAVORAZIONE";
      } else {
        dto.stato = vo.stato;
      }
      if (vo.allegati.length > 0) {
        dto.allegati = this.documentoMapper.convertListVoToDto(vo.allegati);
      }

      dto.primario = this.documentoMapper.convertVoToDto(vo.documentoPrimario);

      dto.struttura = this.mapperSettoreStruttura.convertVoToDto(vo.struttura);
      dto.tempiConservazione = this.mapperTempiConservazione.convertVoToDto(
        vo.tempiConservazione
      );

      if (
        vo.metadatiProtocollo !== null &&
        vo.metadatiProtocollo !== undefined
      ) {
        dto.metadatiProtocollo = this.mapperMetadatiProtocollo.convertListVoToDto(
          vo.metadatiProtocollo
        );
      }
      dto.visibilitaElemento = this.visibilitaElementoMapper.convertListVoToDto(
        vo.visibilitaElemento
      );
      dto.idCorrispondenza = vo.idCorrispondenza;
      dto.idAttribuzione = vo.idAttribuzione;

      if (vo.importDaGescor && !vo.copiaUd) {
        dto.metadatiFascicolo = this.mapperMetaDatiFascicolo.convertVoToDto(
          vo.metadatiFascicolo
        );
      }
      dto.personale = vo.personale;
      dto.importDaGescor = vo.importDaGescor;
      dto.isArrivo = vo.isArrivo;
      dto.importata = vo.importata;
      dto.bloccatoDa = this.mapperUtente.convertVoToDto(vo.bloccatoDa);
      dto.repertoriato = vo.repertoriato;
      dto.segnaturaArchivistica = vo.segnaturaArchivistica;
      dto.metadatiRepertorio = this.mapperMetadatiRepertorio.convertVoToDto(
        vo.metadatiRepertorio
      );
      dto.idCopia = vo.idCopia;
      dto.copiaUd = vo.copiaUd;
      dto.lingue = this.mapperLingia.convertListVoToDto(vo.lingue);
      dto.altraDenominazione = vo.altraDenominazione;
      dto.dimensioni = vo.dimensioni;
      dto.datiPersonali = this.mapperDatiPersonali.convertVoToDto(
        vo.datiPersonali
      );
      dto.riservato = vo.riservato;
      dto.inFirma = vo.inFirma;

      return dto;
    } else {
      return null;
    }
  }

  convertDtoToVo(dto: UnitaDocumentariaDTO): UnitaDocumentariaVO {
    console.log("[MapperUnitaDocumentaria] convertDtoToVo begin ", dto);
    if (dto != null) {
      const vo = new UnitaDocumentariaVO();
      //       vo.riservato = dto.riservato;
      vo.id = dto.id;
      vo.collocazioneFisica = dto.collocazioneFisica;
      vo.classifica = this.classificaMapper.convertDtoToVo(dto.classifica);
      if (dto.classificaAggiuntiva && dto.classificaAggiuntiva.codice) {
        vo.classificaAggiuntiva = this.classificaMapper.convertDtoToVo(
          dto.classificaAggiuntiva
        );
      }
      vo.riferimentoPosizione = this.mapperRiferimentiPosizione.convertDtoToVo(
        dto.riferimentoPosizione
      );
      vo.oggetto = dto.oggetto;
      if (dto.stato === "IN_LAVORAZIONE") {
        vo.stato = "In lavorazione";
      } else if (dto.stato === "IN_BOZZA") {
        vo.stato = "In bozza";
      } else {
        vo.stato = dto.stato;
      }
      vo.visibilitaElemento = this.mapperVisibilitaFascicolo.convertListDtoToVo(
        dto.visibilitaElemento
      );
      vo.idCorrispondenza = dto.idCorrispondenza;
      if (
        dto.metadatiFascicolo !== null &&
        dto.metadatiFascicolo !== undefined
      ) {
        vo.metadatiFascicolo = this.mapperMetaDatiFascicolo.convertDtoToVo(
          dto.metadatiFascicolo
        );
      }
      vo.dataUltimaModifica = dto.dataUltimaModifica;
      vo.dataArchiviazione = dto.dataArchiviazione;
      vo.inseritoDa = this.mapperUtente.convertDtoToVo(dto.inseritoDa);
      vo.dataInserimentoFascicolo = dto.dataInserimentoFascicolo;
      vo.dataInserimento = dto.dataInserimento;
      vo.id = dto.id;
      vo.allegati = this.documentoMapper.convertListDtoToVo(dto.allegati);
      vo.tipo = dto.tipo;
      if (
        dto.metadatiProtocollo !== null &&
        dto.metadatiProtocollo !== undefined
      ) {
        vo.metadatiProtocollo = this.mapperMetadatiProtocollo.convertListDtoToVo(
          dto.metadatiProtocollo
        );
      }
      vo.documentoPrimario = this.documentoMapper.convertDtoToVo(dto.primario);
      vo.struttura = this.mapperSettoreStruttura.convertDtoToVo(dto.struttura);
      vo.tempiConservazione = this.mapperTempiConservazione.convertDtoToVo(
        dto.tempiConservazione
      );
      //       vo.campiSpecifici = this.mapperCampoSpecificoFascicolo.convertListDtoToVo(dto.campiSpecifici);
      vo.visibilitaElemento = this.visibilitaElementoMapper.convertListDtoToVo(
        dto.visibilitaElemento
      );
      vo.importDaGescor = dto.importDaGescor;
      vo.importata = dto.importata;
      vo.bloccatoDa = this.mapperUtente.convertDtoToVo(dto.bloccatoDa);
      vo.isArrivo = dto.isArrivo;
      vo.tipo = dto.tipo;
      vo.repertoriato = dto.repertoriato;
      vo.metadatiRepertorio = this.mapperMetadatiRepertorio.convertDtoToVo(
        dto.metadatiRepertorio
      );
      vo.idCopia = dto.idCopia;
      vo.copiaUd = dto.copiaUd;
      vo.segnaturaArchivistica = dto.segnaturaArchivistica;
      vo.lingue = this.mapperLingia.convertListDtoToVo(dto.lingue);
      vo.altraDenominazione = dto.altraDenominazione;
      vo.dimensioni = dto.dimensioni;
      vo.struttureAggiuntive = this.mapperSettore.convertListDtoToVo(
        dto.struttureAggiuntive
      );
      vo.privato = dto.privato;
      vo.datiPersonali = this.mapperDatiPersonali.convertDtoToVo(
        dto.datiPersonali
      );

      vo.riservato = dto.riservato;
      vo.inFirma = dto.inFirma;

      console.log("[MapperUnitaDocumentaria] convertDtoToVo end ", vo);

      return vo;
    } else {
      return null;
    }
  }

  convertListVoToDto(voList: UnitaDocumentariaVO[]): UnitaDocumentariaDTO[] {
    if (voList != null) {
      return voList.map((vo) => this.convertVoToDto(vo));
    } else {
      return null;
    }
  }

  convertListDtoToVo(dtoList: UnitaDocumentariaDTO[]): UnitaDocumentariaVO[] {
    if (dtoList != null) {
      return dtoList.map((dto) => this.convertDtoToVo(dto));
    } else {
      return null;
    }
  }
}
